<div class="mt-20">
  <!-- {{ 'label.gb.reactivate_pat'] }} -->
  <div style="display: flex; justify-content: space-between; align-items: center">
    <div style="display: flex; align-items: center;">
      <div class="pageTitle">@if (!activatorClinicFlg) {
        <span [id]="identifierService.labelId('patient-device-data', 'patDevData')" data-tx-key="label.gb.pat_dev_data" [innerHTML]="labels['label.gb.pat_dev_data']"></span>
      } @else {
        <span [id]="identifierService.labelId('patientDeviceData', 'demographics')" data-tx-key="label.gb.Demographics">{{ labels['label.gb.pat_prof'] }}</span>
      }</div>
      @if (profileMode()) {
        <div style="margin-bottom: 5px; margin-top: 5px; margin-left: 40px">
          @if (viewMode() && isTP()) {
            <button mat-raised-button color="primary" style="margin-right: 5px" (click)="setDisplayMode('edit')" id="profileEditButton" [disabled]="!userProfile?.canEnroll"
              data-tx-key="label.gb.edit">
              {{ labels['label.gb.edit'] }}
            </button>
          }
          @if (editMode()) {
            <button mat-raised-button color="accent" class="mr-20" (click)="cancelEditClick()" id="profileCancelButton"
              data-tx-key="label.gb.button_cancel">
              {{ labels['label.gb.button_cancel'] }}
            </button>
          }
          @if (editMode()) {
            <button mat-raised-button color="primary" class="mr-5" (click)="checkInsInfo(true,false)" id="profileSaveButton"
                    data-tx-key="label.gb.save">
              {{ labels['label.gb.save'] }}
            </button>
          }
        </div>
      }
    </div>
    @if (profileMode()) {
      <div class="controls">
        <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="printProfileLink" (click)="openPrintDialog()"
          data-tx-key="label.gb.print_profile">
          {{ labels['label.gb.print_profile'] }}
        </div>
        @if (viewMode()) {
<div class="figLink" style="margin-left: 10px; margin-top: 10px" [ngStyle]="{
                'pointer-events': isSP2CanEnroll && isTP() ? 'auto' : 'none',
                color: isSP2CanEnroll && isTP() ? '#03a9f4' : '#9e9e9e'
            }" id="releasePatientLink" (click)="releasePatient()">
            {{ labels['label.gb.release_patient'] }}
          </div>
        }
        @if (viewMode()) {
          <div class="figLink" style="margin-left: 10px; margin-top: 10px" id="moreActionsLink">
            <a [id]="identifierService.buttonId('patientDeviceData', 'moreActions')" [matMenuTriggerFor]="menu" #trigger="matMenuTrigger">
              {{ labels['label.gb.more_actions'] }} &#8942;
            </a>
          </div>
        }
      </div>
    }
  </div>
  <mat-menu #menu="matMenu">
  <button mat-menu-item id="reactivatePatientButton" (click)="reActivatePatient()" [disabled]="!isTP() ? !isTP() : !userProfile?.canEnroll"
    data-tx-key="label.gb.reactivate_pat">
    {{ labels['label.gb.reactivate_pat'] }}
  </button>
</mat-menu>
  @if (displayViewUI() || displayEditUI()){
<div>
  @if (!!msg1) {
    <div class="yellow-card">
      <span [id]="identifierService.labelId('patientDeviceData', 'msg1')">{{ msg1 }}</span>
    </div>
  }
  @if (!!msg2) {
    <div class="yellow-card">
      <span [id]="identifierService.labelId('patientDeviceData', 'msg2')">{{ msg2 }}</span>
    </div>
  }
</div>
  }
@if (displayViewUI() || displayEditUI()) {
  <div>
    @if (!!msg3) {
      <div class="yellow-card">
        <span [id]="identifierService.labelId('patientDeviceData', 'msg3')">{{ msg3 }}</span>
      </div>
    }
  </div>
}
<br />
@if (displayViewUI() || displayEditUI()) {
  <div>
    @if (isPatientRelease) {
      <div class="yellow-card">
        <span [id]="identifierService.labelId('patient-device-data', 'releasePatientMsg')" [innerHTML]="releasePatientMsg"></span>
      </div>
    }
  </div>
}
  <br />
  @if (displayViewUI()){
  <ng-container>
    <view-manual-patient-device-data
      [functionMode]="functionMode"
      [displayMode]="displayMode"
      [patientid]="patientid"
      [getUserObsFunc]="getUserObsFunc"
      [getUserProfFunc]="getUserProfFunc"
      [getDeviceDataFunc]="getDeviceDataFunc"
      (setPatientHeader)="setPatientHeader"
      (setSubMenu)="setSubMenu"
    ></view-manual-patient-device-data >
  </ng-container>
  }
  @if (displayEditUI()){
  <ng-container *ngIf="displayEditUI()">
    <edit-manual-patient-device-data
      [functionMode]="functionMode"
      [displayMode]="displayMode"
      [patientid]="patientid"
      [patRes]="patRes"
      [rpCapableFlg]="rpCapableFlag"
      [userProfile]="userProfile"
      [isActiveStep]="isActiveStep"
      (setPatientHeader)="setPatientHeader"
      (setSubMenu)="setSubMenu"
      (navigateToTrans)="emitNavToTrans($event)"
      (getPatientId)="emitGetPatientId($event)"
      (setDeviceData)="setDeviceData($event)"
      [isBack]="isBack"
      [defaultPatientDetails]="defaultPatientDetails"
      [getUserObsFunc]="getUserObsFunc"
      [getUserProfFunc]="getUserProfFunc"
      [getDeviceDataFunc]="getDeviceDataFunc"
      [getExistingPatientFunc]="getExistingPatientFunc"
      [getEnrollPatientsFunc]="getEnrollPatientsFunc"
      [getEnrollPatientByInsFunc]="getEnrollPatientByInsFunc"
      [getUpdateDeviceDataFunc]="getUpdateDeviceDataFunc"
      [setParentPatientid]="setParentPatientid"
      [setParentDisplayMode]="setParentDisplayMode"
    ></edit-manual-patient-device-data>
  </ng-container>
  }
@if (editMode() || displayMode == 'enroll') {
  <div [id]="identifierService.labelId('patientDeviceData', 'requiredField')" style="color: red" data-tx-key="label.gb.required_field" >* {{ labels['label.gb.required_field'] }}</div>
}
@if (!profileMode()) {
  <div class="col-xs-4 col-sm-offset-8">
    <button mat-raised-button class="btn-styl" color="accent" (click)="cancelButtonClick()" [id]="
      identifierService.buttonId(
          'patient-device-data',
          'enrollCancelButton'
      )
      "
      data-tx-key="label.gb.button_cancel">
      {{ labels['label.gb.button_cancel'] }}</button
      >&nbsp;&nbsp;
      <button
        mat-raised-button
        class="btn-styl"
        color="accent"
        (click)="onSaveAndCloseWithXssValidation()"
        [id]="
          identifierService.buttonId(
              'patient-device-data',
              'enrollSaveCloseButton'
          )
        "
        data-tx-key="label.gb.saveandclose"
        >
        {{ labels['label.gb.saveandclose'] }}</button
        >&nbsp;&nbsp;
        @if (!activatorClinicFlg) {
          <button
            mat-raised-button
            class="btn-styl"
            color="primary"
            (click)="checkInsInfo(false,true)"
            [id]="
              identifierService.buttonId(
                  'patient-device-data',
                  'enrollContinueButton'
              )
              "
            data-tx-key="label.gb.continue"
            >
            {{ labels['label.gb.continue'] }}
          </button>
        }
      </div>
    }
  </div>
